import S3Upload from './S3Upload';
import { getSignedUrl } from '../api/upload';
import { getSmartImage } from '../helpers/helpers';

// Same authenticated signing route and S3 client as DropUploader, for files made in code.
export const uploadFileToS3 = file =>
  new Promise((resolve, reject) => {
    new S3Upload({
      files: [file],
      contentDisposition: 'auto',
      getSignedUrl: (pending, callback) =>
        getSignedUrl({ objectName: pending.name, contentType: pending.type }).then(signedUrl =>
          signedUrl ? callback({ signedUrl }) : reject(new Error('Could not start this upload.'))
        ),
      onFinishS3Put: info => resolve(getSmartImage(info.signedUrl.split('?')[0])),
      onError: status => reject(new Error(status || 'Upload failed'))
    });
  });
